import { render, staticRenderFns } from "./HotelReservationAdministrationStack.vue?vue&type=template&id=b07a0540&"
import script from "./HotelReservationAdministrationStack.vue?vue&type=script&lang=js&"
export * from "./HotelReservationAdministrationStack.vue?vue&type=script&lang=js&"
import style0 from "./HotelReservationAdministrationStack.vue?vue&type=style&index=0&id=b07a0540&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b07a0540')) {
      api.createRecord('b07a0540', component.options)
    } else {
      api.reload('b07a0540', component.options)
    }
    module.hot.accept("./HotelReservationAdministrationStack.vue?vue&type=template&id=b07a0540&", function () {
      api.rerender('b07a0540', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/reservationAdministration/HotelReservationAdministrationStack.vue"
export default component.exports